import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const UNSAFE = ['post', 'put', 'patch', 'delete'];
const nativeFetch = window.fetch.bind(window);

let token = null;
let inflight = null;

export const getCsrfToken = (force = false) => {
  if (token && !force) return Promise.resolve(token);
  if (!inflight) {
    inflight = nativeFetch(`${BACKEND_URL}/api/auth/csrf`, { credentials: 'include' })
      .then((r) => r.json())
      .then((d) => { token = d.csrf_token; return token; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

const isBackend = (url = '') =>
  url.startsWith('/api') || (BACKEND_URL && url.startsWith(BACKEND_URL));

const isUnsafe = (method) => UNSAFE.includes((method || 'get').toLowerCase());

const isCsrfError = (status, data) => status === 403 && data?.detail?.code === 'csrf_invalid';

export const attachCsrf = (instance) => {
  instance.interceptors.request.use(async (config) => {
    const url = (config.baseURL && !/^https?:/.test(config.url || '')) ? config.baseURL + (config.url || '') : config.url;
    if (isUnsafe(config.method) && isBackend(url)) {
      config.headers['X-CSRF-Token'] = await getCsrfToken();
    }
    return config;
  });
  instance.interceptors.response.use(undefined, async (error) => {
    const cfg = error.config;
    if (cfg && !cfg._csrfRetried && isCsrfError(error.response?.status, error.response?.data)) {
      cfg._csrfRetried = true;
      cfg.headers['X-CSRF-Token'] = await getCsrfToken(true);
      return instance(cfg);
    }
    return Promise.reject(error);
  });
};

attachCsrf(axios);

window.fetch = async (input, init = {}) => {
  const url = typeof input === 'string' ? input : input?.url || '';
  const method = init.method || (typeof input === 'object' && input?.method) || 'GET';
  if (!isUnsafe(method) || !isBackend(url)) return nativeFetch(input, init);
  const send = async (force) => {
    const headers = new Headers(init.headers || (typeof input === 'object' ? input.headers : undefined));
    headers.set('X-CSRF-Token', await getCsrfToken(force));
    return nativeFetch(input, { ...init, headers });
  };
  const res = await send(false);
  if (res.status !== 403) return res;
  const data = await res.clone().json().catch(() => null);
  return isCsrfError(res.status, data) ? send(true) : res;
};
